export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/core/translate/maxTranslate.js
// module id = 1182
// module chunks = 9